module.exports = __webpack_public_path__ + "img/logo.5b6e9315.png";